import "babel-polyfill"

import React from "react"
import { Provider } from "react-redux"
import { Route, Switch, Redirect } from "react-router-dom"
import { ConnectedRouter } from "connected-react-router"
import {Nav, NavItem} from "react-bootstrap"

import Login from "./components/Login"
import ReservationsTable  from "./components/tables/ReservationsTable"
import SessionsTable  from "./components/tables/SessionsTable"
import TrackingTable  from "./components/tables/TrackingTable"
import PartnerList  from "./components/tables/PartnerList"
import PartnerPage from "./components/PartnerInfo"
import ReservationDetails from "./components/ReservationDetails"
import UpdateContentPage from "./components/UpdateContentPage"
import UpdateUberPage from "./components/UpdateUberPage"
import PaymentMethods from "./components/PaymentMethods"

import configureStore from "./store/configureStore"

import "./admin.less"

const { history, store } = configureStore()

/**
 * 
 */
const navUrls = [
  "/private/reservations",
  "/private/sessions",
  "/private/tracking",
  "/private/partners",
  "/private/update",
  "/private/updateUber",
]

class App extends React.PureComponent {
  componentDidMount() {
    // add bootstrap css from here
    // <link rel="stylesheet" type="text/css" href="/static/css/bootstrap.css">
    const element = document.createElement("link")
    element.setAttribute("rel", "stylesheet")
    element.setAttribute("type", "text/css")
    element.setAttribute("href", "/static/css/bootstrap.css")
    document.getElementsByTagName("head")[0].appendChild(element)
  }
  
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Switch>
            <Route exact path="/partner/:partnerName" component={PartnerPage} />
            <Route
              render={({ location }) => (
                <div className="admin-main">
                  <Route
                    exact
                    path="/private"
                    render={() => <Redirect to="/private/reservations" />}
                  />

                  <Nav bsStyle="tabs" activeKey={navUrls.findIndex(e => e == location.pathname)}>
                    {
                      [
                        {url: "/private/reservations", title: "Reservas" },
                        {url: "/private/sessions", title: "Sesiones" },
                        {url: "/private/tracking", title: "Tracking" },
                        {url: "/private/partners", title: "Partners" },
                        {url: "/private/update", title: "Actualizar contenido" },
                        {url: "/private/updateUber", title: "Conectar Uber" },
                        {url: "/private/paymentmethods", title: "Formas de pago" },
                      ].map(({ url, title}, i) => (
                        <NavItem key={url} eventKey={i} onClick={() => history.push(url)}>
                          {title}
                        </NavItem>
                      ))
                    }
                  </Nav>
              
                  <div>
                    <Switch>
                      <Route exact path="/private/reservations" component={ReservationsTable} />
                      <Route exact path="/private/sessions" component={SessionsTable} />
                      <Route exact path="/private/tracking" component={TrackingTable} />
                      <Route exact path="/private/partners" component={PartnerList} />
                      <Route exact path="/private/update" component={UpdateContentPage} />
                      <Route exact path="/private/updateUber" component={UpdateUberPage} />
                      <Route exact path="/private/paymentmethods" component={PaymentMethods} />
                      <Route exact path="/private/home" render={() => <Redirect to="/private/reservations" />} />
                      <Route exact path="/private/reservation/:id" component={ReservationDetails} />
                    </Switch>
                  </div>
                </div>
              )}
            />
          </Switch>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default App




// WEBPACK FOOTER //
// ./src/app/admin/index.js